import InitialState from "./InitialState"

export default class ResumeGame extends InitialState {
  constructor(messageString) {
    super(messageString)
    this.type = "resume"
  }
}
